<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="DEDICATION">In loving memory of Christine F. Reid,<br/>whose table was always bountiful and inclusive of all</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reid_Wisdoms_Feast1.vue?dcacee08